import { bl_fi_mst_coupon_line_scan_event_attachment_RowClass } from '../../../dbschema/bl_fi_mst_coupon_line_scan_event_attachment.model';
import {BaseContainerModel} from '../../base-container.model';

export class CouponLineScanEventAttachmentContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_line_scan_event_attachment: bl_fi_mst_coupon_line_scan_event_attachment_RowClass;
}
